/**
 * Zero padding a number
 * @param num The number to be converted
 * @param len The length of the string
 * @returns The string with zero padding
 */
export function zeroPadding(num: number, len: number) {
  let res = String(num);
  while (res.length < len) {
    res = '0' + res;
  }
  return res;
}
